import React, {useState, useEffect, useCallback} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import FullBodyMenuView from '../../views/fullBodyMenuView';
import {useMenu} from '../../../hooks/useMenu';
import ChannelConfig from './channel-config';
import SetModbus from './set-modbusTN';
import SensorParameters from './sensor';
import SetLowerRangeValue from './SLRV';
import {useTranslation, withTranslation, Trans} from 'react-i18next';

function ChannelSelection() {
  const {onComponent} = useMenu();
  const {t, i18n} = useTranslation();
    const changeLanguage = lng => {
      i18n.changeLanguage(lng);
    };
  const channelItem = [
    {
      id: 1,
      name: 'Channel A',
      children: [
        {
          id: 11,
          name: 'Milliamp Output 1',
          children: [
              {id: 1111, name: 'Mass Flow Rate', requireDoubleRight: true},
              {id: 1112, name: 'Volume Flow Rate', requireDoubleRight: true},
              {id: 1113, name: 'Drive Gain', requireDoubleRight: true},
              {id: 1114, name: 'GSV Flow Rate', requireDoubleRight: true},
              {id: 1115, name: 'Velocity', requireDoubleRight: true},
              {id: 1116, name: 'Temperature', requireDoubleRight: true},
              {id: 1117, name: 'Density', requireDoubleRight: true},
              {id: 1118, name: 'External Pressure', requireDoubleRight: true},
              {id: 1119, name: 'External Temperature', requireDoubleRight: true},
              {id: 1120, name: 'External Density', requireDoubleRight: true},
              {id: 1122, name: 'PV_PG_FLOW_SEVERITY', requireDoubleRight: true},
              {id: 1123, name: 'Referred Density', requireDoubleRight: true},
              {id: 1124, name: 'Referred Volume Flow',requireDoubleRight: true},
              {id: 1125, name: 'Avg. Line Density', requireDoubleRight: true},
              {id: 1126, name: 'Avg. Temperature', requireDoubleRight: true},
              {id: 1127, name: 'Referred Density', requireDoubleRight: true},
              {id: 1128, name: 'Specific Gravity', requireDoubleRight: true},
              {id: 1129, name: 'Standard Vol Flow', requireDoubleRight: true},
              {id: 1130, name: 'Net Mass Flow', requireDoubleRight: true},
              {id: 1131, name: 'Net Volume Flow Rate', requireDoubleRight: true},
              {id: 1132, name: 'Concentration', requireDoubleRight: true},
          ],
        },
        {
          id: 12,
          name: 'Frequency Output 2',
          children: [
              {id: 121, name: 'POWER_INTERNAL', requireDoubleRight: true},
              {id: 122, name: 'POWER_EXTERNAL', requireDoubleRight: true},
          ],
        },
        {
          id: 13,
          name: 'Discrete Output 2',
          children: [
            {id: 131, name: 'POWER_INTERNAL', requireDoubleRight: true},
            {id: 132, name: 'POWER_EXTERNAL', requireDoubleRight: true}
          ],
        },
      ],
    },
    {
      id: 2,
      name: 'Channel B',
      children: [
        {
          id: 21,
          name: 'Milliamp Output 2',
          children: [
              {id: 211, name: 'POWER_INTERNAL', requireDoubleRight: true},
              {id: 212, name: 'POWER_EXTERNAL', requireDoubleRight: true}
          ]
        },
        {
          id: 22, 
          name: 'Frequency Output',
          children: [
            {id: 221, name: 'POWER_INTERNAL', requireDoubleRight: true},
            {id: 222, name: 'POWER_EXTERNAL', requireDoubleRight: true}
          ]
        },
        {
          id: 23, 
          name: 'Discrete Output 1',
          children: [
            {id: 231, name: 'POWER_INTERNAL', requireDoubleRight: true},
            {id: 232, name: 'POWER_EXTERNAL', requireDoubleRight: true}
          ]
        },
        {
          id: 24, 
          name: 'Discrete Input 1',
          children: [
            {id: 241, name: 'POWER_INTERNAL', requireDoubleRight: true},
            {id: 242, name: 'POWER_EXTERNAL', requireDoubleRight: true}
          ]
        },
        {
          id: 25, 
          name: 'None',
          children: [
            {id: 251, name: 'POWER_INTERNAL', requireDoubleRight: true},
            {id: 252, name: 'POWER_EXTERNAL', requireDoubleRight: true}
          ]
        },
      ],
    },
    {
      id: 3,
      name: "Channel C",
      component: <SetModbus />
    },
    {id: 4, name: 'Finished', component: <SensorParameters />},
  ];

  // const leftPress = useKeyPress('ArrowLeft');

  // const onLeft = useCallback(() => {
  //   onComponent(<ChannelConfig />);
  // }, []);

  // useEffect(() => {
  //   if (!leftPress) return;

  //   // onComponent(<ChannelConfig />);
  // }, [leftPress]);

  return (
    <FullBodyMenuView
      title={t('channelConfig.title')}
      menuItems={channelItem}
      isMenuDisabled
      onLeftCallback={() => onComponent(<ChannelConfig />)}
    />
  );
}

export default ChannelSelection;
